import {loggerFactory} from "@cm/browser-log"
import {ImageOpContext} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context"
import {TexturesApiService} from "@app/textures/service/textures-api.service"

export abstract class ImageOpContextBase implements ImageOpContext {
    abstract readonly type: string

    readonly logger = loggerFactory.getLogger("image-op-system")

    constructor(readonly texturesApi: TexturesApiService) {}

    dispose(): void {}
}
